<div class="score-board" *ngIf="showScoreBoard">
    <h3 class="title">
        <ng-container *ngIf="overAllQualityScore =='Good'">
            <img src="/assets/icons/vector_green.svg" alt="Average Quality Score" />
        </ng-container>
        <ng-container *ngIf="overAllQualityScore =='Medium'">
            <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
        </ng-container>
        <ng-container *ngIf="overAllQualityScore =='Low'">
            <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
        </ng-container>
        Average Quality Score: {{ overAllQualityScore }}

        <mat-icon class="score-close-tablet">
            close
        </mat-icon>
    </h3>

    <div class="score-details">
        @for (data of qualityScore; track data.section) {
        <div class="score-item" [class.good]="data.score >= 80"
            [class.average]="data.score >= 50 && data.score < 80" [class.danger]="data.score < 50">
            <div>
                <p class="section-title">{{ data.section }}</p>
                <p class="risk-text">Quality Score {{ data.score }}%</p>
            </div>
             @if (data.showBotProgress) {
            <div class="icon-overlay">
                <img src="/assets/icons/Vector.svg" alt="vector" class="vector-icon" />
                <img src="/assets/icons/robot.svg" alt="robot" class="robot-icon" />
            </div>
            } @else {
            @if (data.score >= 80) {
            <img src="/assets/icons/check_circle_26.svg" alt="check" />
            }
            @if (data.score >= 50 && data.score
            < 80) { <img src="/assets/icons/error_26.svg" alt="warning" />
            }
            @if (data.score
            < 50) { <img src="/assets/icons/cancel_26.svg" alt="danger" />
            }
            }
        </div>
        }
    </div>

</div>
